import { render, staticRenderFns } from "./alloffon.vue?vue&type=template&id=2c88928b&scoped=true"
import script from "./alloffon.vue?vue&type=script&lang=js"
export * from "./alloffon.vue?vue&type=script&lang=js"
import style0 from "./alloffon.vue?vue&type=style&index=0&id=2c88928b&prod&scoped=true&lang=css"
import style1 from "./alloffon.vue?vue&type=style&index=1&id=2c88928b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c88928b",
  null
  
)

export default component.exports